export default __webpack_public_path__ + "static/media/brodinski_feat_bloody_jay_1_lowdef.2908a778.png";